module.exports = __webpack_public_path__ + "img/zs_13@2x.d1140507.png";